/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { LoadingContainer } from 'components/loadingContainer'
import { useDeleteDialog } from 'hooks/admin/useDeleteDialog'
import { useEventById } from 'hooks/admin/useEvents'

import { EventCard } from './eventCard'
import { Container } from './eventCard.style'

interface Props {
    eventId: string
    onEdit: (data: any) => void
    onDelete: (id: any) => void
}

export const EventCardAdmin = ({ eventId, onEdit }: Props) => {
    const { show: eventDeleteDialog, DialogComponent: DeleteDialog } = useDeleteDialog()
    const { data, isLoading, error } = useEventById(eventId)

    return (
        <Container>
            <LoadingContainer isLoading={isLoading} error={error}>
                {data && <EventCard data={data} onEdit={onEdit} />}
                <DeleteDialog entityLabel={'az eseményt'} />
            </LoadingContainer>
        </Container>
    )
}
